export default "__VITE_ASSET__LMXuqI1z__"